export const types = {
  HIDE_SPINNER: "HIDE_SPINNER",
  SHOW_SPINNER: "SHOW_SPINNER",
  ERROR: "ERROR",
  GET_RATES: "GET_RATES",
  UPDATE_AMOUNT: "UPDATE_INPUT_VALUE",
  UPDATE_FROM_COUNTRY: "UPDATE_FROM_COUNTRY",
  UPDATE_TO_COUNTRY: "UPDATE_TO_COUNTRY",
  SWAP_VALUES: "SWAP_VALUES",
};
